<template>
	<transition name="offline-ch">
		<div class="offline-ch">
			<div id="btn" @click="hidden"></div>
			<p v-for="(el, i) in offlineCh" :key="i">{{el}}</p>
		</div>
	</transition>
</template>
<script>
import { mapGetters } from "vuex";

export default {
	name: "TotalOfflineCh",
	data() {
		return {
			offlineCh: []
		};
	},
	mounted() {
		this.offlineCh = [];
		this.$store.state.offlineStreams.forEach(ch => {
			this.offlineCh.push(ch.display_name);
		});
	},
	computed: {
		...mapGetters([""])
	},
	methods: {
		hidden() {
			this.$emit("hidden", {});
		}
	}
};
</script>
<style scoped lang="scss">
.offline-ch {
	position: absolute;
	margin: 4rem;
	top: 0;
	width: 20rem;
	height: 20rem;
	min-height: 20rem;
	background-color: rgba(197, 204, 203, 0.9);
	overflow: auto;
	padding: 1rem;
	border-radius: 3px;
	box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.52);
	z-index: 11000;

	p {
		margin-top: -1rem;
	}

	#btn {
		position: sticky;
		width: 20px;
		height: 20px;
		background: url('../../static/close.png') no-repeat center;
		background-size: 100%;
		top: 0;
		transform: translateX(14.5rem);
		margin: 0 1rem 0 1rem;
		cursor: pointer;
	}
}

.offline-ch-enter-active {
	transition: all 0.4s ease;
}

.offline-ch-leave-active {
	transition: all 0.4s ease;
}

.offline-ch-enter, .offline-ch-leave-to {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/TotalOfflineCh.vue